//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {Link} from 'react-router-dom'
//@end

//@import components
import NewsItemSkeleton from 'app_components/screens/landing/newsitem/components/newsItemSkeleton';
import NewsItemImportantSkeleton from 'app_components/screens/landing/newsitem/components/newsItemImportantSkeleton';
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import ContentNewsCommon from 'app_components/commons/contentnews'
import TagsCommon from 'app_components/commons/tags'
import SeparatorHorCommon from 'app_components/commons/separatorhor'
import NewsCardCommon from 'app_components/commons/newsCard'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
//@end

// @import hooks
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../newsitemScreen.scss'

// @ADD Component types
interface INewsitemScreenLayoutProps {
  post: IPost | null
  posts: Array<any>
  loading_post: boolean
  loading_posts: boolean
}

const NewsitemScreenLayout: React.FC<INewsitemScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const { windowWidth } = useWindowWidth()

  return(
    <PublicAppLayout>

      <div className={'news-item-s'}>
        <BannerTextPrimaryCommon text={'Noticias'}/>
        <div
          className='container-news-famous'
        >
          <div>
            {props.loading_post ? (
              <NewsItemSkeleton />
            ) : (
              <>
                {props.post ? (
                  <ContentNewsCommon news={props.post}/>
                ) : (
                  <div className="mt-3">
                    <AlertComponent
                      type='warning'
                      title={t('screens.news.no_data')}
                    />
                  </div>
                )}
              </>
            )}
          </div>
          <div>
            {props.loading_posts ? (
              <NewsItemImportantSkeleton />
            ): (
              <>
                <div className={'news-item-destacados'}>
                  <span className={'news-item-title'}>{t('screens.news.important.title')}</span>
                  <SeparatorHorCommon/>
                  <br />
                  {props.posts && props.posts.length > 0 ? (
                    <>
                      {props.posts.map((post) => (
                        <Link to={routingService.getPublicPath(`/noticia/${post.slug}`)} key={post.key}>
                          <NewsCardCommon
                            {...post}
                            list={windowWidth < 991 ? true : false}
                          />
                        </Link>
                      ))}
                    </>
                  ) : (
                    <div className="mt-3">
                      <AlertComponent
                        type='warning'
                        title={t('screens.news.important.no_data')}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <SeparatorHorCommon/>
        <div className="end-section"></div>
      </div>
    </PublicAppLayout>
  )
}

export default NewsitemScreenLayout
